const HeaderVariant = {
  withoutBranding: 0,
  withBranding: 1,
  withBrandingTopBar: 2,
};

export default HeaderVariant;
